/* eslint-disable react-refresh/only-export-components */
import { config, EnvName } from '@/config';

// The label shown in the non-prod banner, or null when prod (no banner).
export function envBadgeLabel(env: EnvName, isProd: boolean): string | null {
  if (isProd) return null;
  return env.toUpperCase();
}

// A slim, fixed-height bar that names the current non-prod environment. Renders
// nothing in production so prod stays clean. Visible both inside Outlook and on
// the taskpane site in a browser (it is the same app in both).
export function EnvBanner() {
  const label = envBadgeLabel(config.build.env, config.build.isProd);
  if (!label) return null;
  const background = config.build.env === 'staging' ? '#b54708' : '#5b5fc7';
  return (
    <div
      role="status"
      aria-label={`Environment: ${label}`}
      style={{
        height: 20,
        lineHeight: '20px',
        textAlign: 'center',
        fontSize: 11,
        fontWeight: 600,
        letterSpacing: '0.08em',
        color: '#ffffff',
        background,
        flex: '0 0 auto',
      }}
    >
      {label}
    </div>
  );
}
